import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaPhone,
  FaTiktok,
  FaChevronRight,
} from "react-icons/fa";
import { SiGooglemaps } from "react-icons/si";
import { AiTwotoneMail } from "react-icons/ai";

export default function Footer() {
  const whatsappUrl = "https://wa.me/593995149001";

  const matrizDireccion =
    "Calle Rocafuerte entre Ricardo Garcés, y Vicente Maldonado";

  const sucursalDireccion = "Yambo, Salcedo, Cotopaxi, Ecuador";

  const googleMapsUrl =
    "https://www.google.com/maps?ll=-1.044308,-78.585298&z=15&t=m&hl=es-419&gl=EC&mapclient=embed&cid=15494071838965387041";

  return (
    <footer className="bg-white border-t border-green-100">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl bg-green-700 flex items-center justify-center shadow-sm">
                <span className="text-white text-xl font-black">V</span>
              </div>

              <div>
                <h2 className="text-2xl font-black text-green-800 tracking-wide">
                  VALEDMO
                </h2>

                <p className="text-[10px] uppercase tracking-widest font-bold text-green-600">
                  Importadora Agropecuaria
                </p>
              </div>
            </div>

            <p className="text-sm text-gray-500 leading-6 mb-5">
              Soluciones agrícolas, sistemas de riego, maquinaria y ferretería
              para el campo ecuatoriano.
            </p>
            <div className="space-y-3">
              <a
                href="tel:+593995149001"
                className="flex items-center gap-3 text-sm text-gray-600 hover:text-green-700 transition-colors"
              >
                <span className="w-8 h-8 rounded-lg bg-green-50 text-green-700 flex items-center justify-center">
                  <FaPhone size={13} />
                </span>
                +593 99 514 9001
              </a>

              <a
                href="mailto:clientes@valedmo.com"
                className="flex items-center gap-3 text-sm text-gray-600 hover:text-green-700 transition-colors"
              >
                <span className="w-8 h-8 rounded-lg bg-green-50 text-green-700 flex items-center justify-center">
                  <AiTwotoneMail size={15} />
                </span>
                clientes@valedmo.com
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-gray-800 mb-5">Enlaces</h3>
            <ul className="space-y-3">
              {[
                { name: "Inicio", href: "/" },
                { name: "Tienda Catálogo", href: whatsappUrl },
                // { name: "Galería de Proyectos", href: whatsappUrl },
                { name: "Nosotros", href: whatsappUrl },
                { name: "Contacto", href: whatsappUrl },
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    target={item.href.startsWith("http") ? "_blank" : undefined}
                    rel={
                      item.href.startsWith("http")
                        ? "noopener noreferrer"
                        : undefined
                    }
                    className="group flex items-center gap-2 text-sm text-gray-500 hover:text-green-700 transition-all"
                  >
                    <FaChevronRight
                      size={8}
                      className="text-green-600 group-hover:translate-x-1 transition-transform"
                    />
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-gray-800 mb-5">Ubicaciones</h3>
            <div className="space-y-3">
              <div className="rounded-xl border border-green-100 bg-green-50/60 p-3.5">
                <div className="flex gap-3">
                  <div className="w-9 h-9 shrink-0 rounded-lg bg-green-700 text-white flex items-center justify-center">
                    <SiGooglemaps size={15} />
                  </div>

                  <div>
                    <p className="text-sm font-bold text-gray-800">
                      Matriz Salcedo
                    </p>
                    <p className="text-xs text-gray-500 leading-5 mt-0.5">
                      {matrizDireccion}
                    </p>
                  </div>
                </div>
              </div>

              <div className="rounded-xl border border-gray-100 bg-gray-50 p-3.5">
                <div className="flex gap-3">
                  <div className="w-9 h-9 shrink-0 rounded-lg bg-white border border-gray-200 text-green-700 flex items-center justify-center">
                    <SiGooglemaps size={15} />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-800">
                      Agencia Yambo
                    </p>
                    <p className="text-xs text-gray-500 leading-5">
                      {sucursalDireccion}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-5">
              <h3 className="font-bold text-gray-800">Encuéntranos</h3>

              <SiGooglemaps className="text-green-600" size={20} />
            </div>

            <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
              <iframe
                title="Salcedo - VALEDMO"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.1556273166693!2d-78.5852992!3d-1.0442951999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d47df649edb7b9%3A0xd706003f15ea4f21!2sIMPORTADORA%20AGROPECUARIA%20VALEDMO!5e0!3m2!1ses-419!2sec!4v1787952409909!5m2!1ses-419!2sec"
                width="100%"
                height="180"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <a
              href={googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 mt-2.5 w-full rounded-lg bg-green-700 text-white py-2.5 text-xs font-bold hover:bg-green-800 transition-colors"
            >
              <SiGooglemaps size={14} />
              Abrir en Google Maps
            </a>
          </div>
        </div>

        <div className="mt-9 pt-6 border-t border-gray-100">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
            <p className="text-sm text-gray-500">
              Síguenos y descubre novedades de{" "}
              <span className="font-bold text-green-700">VALEDMO</span>
            </p>
            <div className="flex gap-2.5">
              <a
                href="https://www.facebook.com/valedmo"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 rounded-lg bg-blue-50 border border-blue-100 text-[#1877F2] flex items-center justify-center hover:bg-[#1877F2] hover:text-white hover:-translate-y-0.5 transition-all"
              >
                <FaFacebook size={16} />
              </a>

              <a
                href="https://www.instagram.com/valedmoimportadoraagropecuaria/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 rounded-lg bg-pink-50 border border-pink-100 text-[#E4405F] flex items-center justify-center hover:bg-gradient-to-tr hover:from-[#f9ce34] hover:via-[#ee2a7b] hover:to-[#6228d7] hover:text-white hover:-translate-y-0.5 transition-all"
              >
                <FaInstagram size={16} />
              </a>

              <a
                href="https://www.tiktok.com/@valedmoimportadoraagro"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="w-9 h-9 rounded-lg bg-zinc-50 border border-zinc-200 text-[#000000] flex items-center justify-center hover:bg-black hover:text-white hover:-translate-y-0.5 transition-all"
              >
                <FaTiktok size={16} />
              </a>

              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-9 h-9 rounded-lg bg-green-50 border border-green-100 text-[#25D366] flex items-center justify-center hover:bg-[#25D366] hover:text-white hover:-translate-y-0.5 transition-all"
              >
                <FaWhatsapp size={17} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-green-50">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs">
            <p className="text-green-800 text-center sm:text-left">
              © {new Date().getFullYear()}{" "}
              <span className="font-bold text-green-900">VALEDMO</span> · Todos
              los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
